import { useCallback, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";

const KEY = "sacristy.shortlist.v1";

export function useShortlist() {
  const [ids, setIds] = useLocalStorage<string[]>(KEY, []);

  const set = useMemo(() => new Set(ids), [ids]);

  const has = useCallback((volunteerId: string) => set.has(volunteerId), [set]);

  const toggle = useCallback(
    (volunteerId: string) => {
      setIds((prev) =>
        prev.includes(volunteerId)
          ? prev.filter((v) => v !== volunteerId)
          : [...prev, volunteerId],
      );
    },
    [setIds],
  );

  return { ids, has, toggle };
}
